import { environment } from 'src/environments/environment';

export class HelperService {
  static debounce = (func, delay = 3000) => {
    let debounceTimer;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(context, args), delay);
      };
  }
  static getQueryString(find: any = {}, select: any = []) {
      const keywords = Object.keys(find);
      const specialOperator = [
        'sort',
        'limit',
        'offset',
      ];
      let queryString = keywords.reduce((acc, keyword, index) => {
        const findCondition = find[keyword];
        if (specialOperator.includes(keyword)) {
          acc += `${keyword}=${findCondition}`;
        } else if (findCondition instanceof Array) {
          acc += `${keyword}__in=${findCondition.join(',')}`;
        } else if (typeof findCondition === 'object' ) {
          acc += this.makeConditionQuery(keyword, findCondition);
        } else {
          acc += `${keyword}__eq=${findCondition}`;
        }
        acc += `&`;
        return acc;
      }, '');
      if (select && select.length) {
        queryString += `select=${select.join(',')}`;
      }
      return queryString;
  }
  static queryString(query: any = {}) {
    const keywords = Object.keys(query);
    const queryString = keywords.reduce((acc, keyword) => {
      const findCondition = query[keyword];
      // if (specialOperator.includes(keyword)) {
      //   acc += `${keyword}=${findCondition}`;
      // } else if (findCondition instanceof Array) {
      //   acc += `${keyword}__in=${findCondition.join(',')}`;
      // } else if (typeof findCondition === 'object' ) {
      //   acc += this.makeConditionQuery(keyword, findCondition);
      // } else {
        acc += `${keyword}=${findCondition}`;
      // }
      acc += `&`;
      return acc;
    }, '');
    return queryString;
  }
  static makeConditionQuery(parent: string, condition: any) {
    const conditionOperators = Object.keys(condition);
    const conditionQueryString = conditionOperators.map(cond => {
      return `${parent}__${cond}=${condition[cond]}`;
    });
    return conditionQueryString.join('&');
  }
  static timestampToReadableFormat(timeStamp: Date) {
    const date = new Date(timeStamp);
    const timeString = date.toLocaleTimeString().split(':').splice(0, 2).join(':');
    return `${timeString} ${HelperService.dateString(date)}`;
  }

  static isValidDate(date: Date) {
    return (date && date.getTime()) ? true : false;
  }

  static get SHARED_IDENTITY_COOKIE_NAMES(): string[] {
    const names = environment.sharedIdentityCookieNames;
    return Array.isArray(names) && names.length ? names : ['token', 'permission'];
  }

  static get AUTH_COOKIE_MAX_AGE_SEC(): number {
    const maxAge = Number(environment.authCookieMaxAgeSec);
    return isFinite(maxAge) && maxAge > 0 ? maxAge : 12 * 60 * 60;
  }

  static setCookie(data: any = {}) {
    Object.keys(data).map(key => {
      let value = data[key];
      if (typeof value === 'object') {
        value = JSON.stringify(value);
      }
      document.cookie = `${key}=${value};path=/`;
    });
  }

  /** Serialize permission list for the shared `permission` cookie (comma-joined slugs). */
  static serializePermissionCookieValue(permission: any): string {
    if (!permission && permission !== 0) {
      return '';
    }
    if (typeof permission === 'string') {
      return permission.split(',').map((p) => p.trim()).filter(Boolean).join(',');
    }
    if (!Array.isArray(permission)) {
      return '';
    }
    return permission.map((item) => {
      if (typeof item === 'string') {
        return item.trim();
      }
      return (item && (item.name || item.slug)) || '';
    }).filter(Boolean).join(',');
  }

  static getAuthCookieWriteOptions(): {
    domain?: string;
    sameSite: string;
    secure: boolean;
    maxAge: number;
  } {
    const domain = HelperService.getSharedCookieDomain();
    const secure = typeof window !== 'undefined' && window.location.protocol === 'https:';
    return {
      ...(domain ? { domain } : {}),
      sameSite: secure ? 'None' : 'Lax',
      secure,
      maxAge: HelperService.AUTH_COOKIE_MAX_AGE_SEC,
    };
  }

  static writeAuthCookie(name: string, value: string, options: {
    domain?: string;
    sameSite?: string;
    secure?: boolean;
    maxAge?: number;
  } = {}) {
    if (!name || !value) {
      return;
    }
    const attrs = [
      'path=/',
      `max-age=${options.maxAge != null ? options.maxAge : HelperService.AUTH_COOKIE_MAX_AGE_SEC}`,
    ];
    if (options.domain) {
      attrs.push(`domain=${options.domain}`);
    }
    if (options.sameSite) {
      attrs.push(`SameSite=${options.sameSite}`);
    }
    if (options.secure) {
      attrs.push('Secure');
    }
    // Encode so JWT / permission payloads never break cookie parsing.
    document.cookie = `${name}=${encodeURIComponent(value)};${attrs.join(';')}`;
  }

  /**
   * Writes shared-parent-domain auth cookies (host-only on localhost).
   * Same contract CSCC primes for payroll: token / permission.
   */
  static setAuthCookies(session: {
    token?: string;
    permission?: any;
  } = {}) {
    const options = HelperService.getAuthCookieWriteOptions();
    const token = HelperService.normalizeAuthToken(session.token || '');
    if (token) {
      HelperService.writeAuthCookie('token', token, options);
    }
    const permission = HelperService.serializePermissionCookieValue(session.permission);
    if (permission) {
      HelperService.writeAuthCookie('permission', permission, options);
    }
  }

  static regexString(string) {
    return `${string}$/i`;
  }
  static roundNumber(num) {
    // const roundTwoDecimal = (num) => {
      return Math.round(num * 100) / 100;
    //  };
  }
  static accessCookie(cookieName) {
    const name = cookieName + '=';
    const allCookieArray = document.cookie ? document.cookie.split(';') : [];
    let emptyMatch = '';
    for (let i = 0; i < allCookieArray.length; i++) {
      const temp = allCookieArray[i].trim();
      if (temp.indexOf(name) !== 0) {
        continue;
      }
      let value = temp.substring(name.length, temp.length);
      if (value.indexOf('%') !== -1) {
        try {
          value = decodeURIComponent(value);
        } catch (e) {
          // keep raw value when decode fails
        }
      }
      // Prefer non-empty values so a stale host-only `token=` does not
      // shadow the shared-domain SSO cookie primed by CSCC.
      if (value) {
        return value;
      }
      emptyMatch = value;
    }
    return emptyMatch;
  }

  /** Matches CSCC embedAuthBootstrap domain scoping for shared SSO cookies. */
  static getSharedCookieDomainForHostname(hostname: string): string {
    if (!hostname || hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
      return '';
    }
    const labels = hostname.split('.');
    if (labels.length < 2) {
      return '';
    }
    const envLabel = labels.length >= 3 ? labels[labels.length - 3] : '';
    const shouldScopeToEnv = ['staging', 'develop'].includes(envLabel);
    return `.${labels.slice(shouldScopeToEnv ? -3 : -2).join('.')}`;
  }

  static getSharedCookieDomain(): string {
    if (typeof window === 'undefined') {
      return '';
    }
    return HelperService.getSharedCookieDomainForHostname(window.location.hostname);
  }

  static normalizeAuthToken(raw: string): string {
    if (!raw) {
      return '';
    }
    let token = String(raw).trim();
    // Decode first so URI-encoded "Bearer%20…" cookies still lose the prefix.
    if (token.indexOf('%') !== -1) {
      try {
        token = decodeURIComponent(token);
      } catch (e) {
        // keep raw token when decode fails
      }
    }
    return token.replace(/^Bearer\s+/i, '').trim();
  }

  static expireCookie(name: string, options: {
    domain?: string;
    sameSite?: string;
    secure?: boolean;
  } = {}) {
    const attrs = [
      'path=/',
      'max-age=0',
      'expires=Thu, 01 Jan 1970 00:00:00 GMT',
    ];
    if (options.domain) {
      attrs.push(`domain=${options.domain}`);
    }
    if (options.sameSite) {
      attrs.push(`SameSite=${options.sameSite}`);
    }
    if (options.secure) {
      attrs.push('Secure');
    }
    document.cookie = `${name}=;${attrs.join(';')}`;
  }

  /**
   * Clears host-only cookies and CSCC shared-domain identity cookies
   * (token / permission) so SSO sessions end on logout.
   */
  static clearAuthCookies() {
    const hostCookieNames = document.cookie
      ? document.cookie.split(';').map((part) => {
        const eqPos = part.indexOf('=');
        return (eqPos > -1 ? part.substring(0, eqPos) : part).trim();
      }).filter(Boolean)
      : [];

    hostCookieNames.forEach((name) => {
      HelperService.expireCookie(name);
    });

    const domain = HelperService.getSharedCookieDomain();
    if (!domain) {
      return;
    }
    const secure = typeof window !== 'undefined' && window.location.protocol === 'https:';
    const sharedOptions = {
      domain,
      sameSite: secure ? 'None' : 'Lax',
      secure,
    };
    HelperService.SHARED_IDENTITY_COOKIE_NAMES.forEach((name) => {
      HelperService.expireCookie(name, sharedOptions);
    });
  }

  static dateString(date: any) {
    if (date && Date.parse(date)) {
      return new Date(date).toDateString();
    }
    return 'N/A';
  }

  static getCurrentUrl() {
    return window.location.href;
  }

  static getCurrentPath() {
    return window.location.pathname;
  }

  static reload() {
    return window.location.reload();
  }

  static routeParams(): any {
    return decodeURIComponent(window.location.search.substring(1)).split('&')
      .reduce((acc, keyValue) => {
        const data = keyValue.split('=');
        acc[data[0]] = data[1];
        return acc;
        }, {});
  }

  static removeParam(params: string[] = []) {
    const baseUrl = window.location.origin;
    const pathname = window.location.pathname;
    const routeParams = this.routeParams();
    const filteredParams = Object.keys(routeParams).reduce((acc, param) => {
      if (!params.includes(param)) {
        acc[param] = routeParams[param];
      }
      return acc;
    }, {});
    return `${baseUrl}${pathname}?${HelperService.queryString(filteredParams)}`;
  }

  static minutesToReadableHourMinuteFormat(minutes: number) {
    const date = new Date('1-1-2019');
    date.setMinutes(minutes);
    let readableString = '';
    if (date.getHours()) {
      readableString = `${date.getHours()} hours`;
    }
    if (date.getMinutes()) {
      readableString += ` ${date.getMinutes()} min`;
    }
    return readableString.trim();
  }

  static encode(data: string) {
    return btoa(btoa(data));
  }

  static decode(data: string) {
    try {
      return atob(atob(data));
    } catch (err) {
      console.log(err);
      return data;
    }
  }

  static redirectToOldDashboard(relativeRoute, queryParams = {}) {
    const basePath = environment.rapido_dashboard;
    const token = HelperService.accessCookie('token');
    const queryString = HelperService.queryString(Object.assign({token}, queryParams));
    const path = `${basePath}/${relativeRoute}?${queryString}`;
    // const path = `${basePath}/${relativeRoute}?token=${token}`;
    // window.location.replace(path);
    window.open(path);
  }

  static redirectToNewPage(url) {
    window.open(url);
  }
  static redirect(url: string) {
    const referrer = document.URL;
    window.location.replace(`${url}?referrer=${referrer}`);
  }

  static openInMap(lat, lng) {
    if (lat && lng) {
      const googleUrl = `https://maps.google.com/?q=${lat},${lng}`;
      this.redirectToNewPage(googleUrl);
    }



  }

  static deocodeJwtPayload(data: string) {
    let base64Url = data.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let response = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return response;
  }

}
